/**
 * The mailbox the agent last worked in. Written by the inbox page and read wherever a support
 * surface needs a sensible default mailbox (e.g. the new-ticket modal opened outside the inbox).
 */
export const LAST_MAILBOX_STORAGE_KEY = 'admin-support-inbox-last-mailbox-id';
